// file for desktop newsletter signup

jQuery(document).ready(function(){
 var contactp = getUrlVars()["contact_posted"];
  if(contactp == 'true'){
    
    jQuery('html, body').animate({
        scrollTop: $("#contact_form").offset().top
    }, 1000);
  }

var attr= jQuery('#contact_form').attr('action');
 var newAttr=attr.replace("#contact_form", ""); 
  jQuery('#contact_form').attr('action',newAttr) 
  
  jQuery('.contact_tech').click(function(e){
  e.preventDefault();
    var $form=jQuery('#contact_form');
    
    // added by danielle //
    var doodoo = jQuery('.email_tech').val();
    if (!isValidEmailAddress(doodoo)) { 
      jQuery('.error_tech').show();
      jQuery('.tech_sc').hide();
      //alert("Oops, please enter a valid email address."); 
    }
    /////
    
    else { // do the signup 
      var data={
        'contact[email]':jQuery('.email_tech').val(),
        //'contact[tags]':'desktop-signup',
        'form_type':'customer',
        'utf8':'✓'
      }
     jQuery.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: data,
          error       : function(err) { 
            jQuery('.error_tech').show();
            jQuery('.tech_sc').hide();
          },
          success     : function(data) {
             cuteRain();
             jQuery('.tech_sc').show();
             jQuery('.error_tech').hide();
          }
      });
    }  
  
  })
})
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

// added by danielle //
// won't accept email addresses with dashes in domain - need to fix this
function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
};